import React, { useEffect, useState } from "react";
import {
  Box, Typography, CircularProgress, Alert, Table, TableHead,
  TableRow, TableCell, TableBody, Paper
} from "@mui/material";
import { getScenarioUsage } from "../../services/UserTransaction/service";
import { ScenarioUsageResponse } from "../../types/models";

const Scenarios: React.FC = () => {
  const [scenarioData, setScenarioData] = useState<ScenarioUsageResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchScenarioUsage = async () => {
      try {
        const data = await getScenarioUsage();
        setScenarioData(data);
      } catch (err) {
        setError((err as Error).message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
      
    };
    
    fetchScenarioUsage();
  }, []);



  const totalUsage = scenarioData.reduce((acc, scenario) => acc + scenario.overall_usage, 0);
  const totalUsers = scenarioData.reduce((acc, scenario) => acc + scenario.unique_users, 0);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: "#0D1117" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert
        severity="error"
        sx={{ backgroundColor: "#FF4B4B", color: "#FFFFFF", maxWidth: "600px", margin: "auto" }}
      >
        {error}
      </Alert>
    );
  }

  return (
    <Box sx={{ p: 4, backgroundColor: "rgba(14, 23, 32, 0)", minHeight: "100vh" }}>
      <Typography variant="h4" gutterBottom sx={{ color: "#FFFFFF", fontWeight: "bold" }}>
        Analytics
      </Typography>

      <Paper elevation={0} sx={{backgroundColor: "rgba(14, 23, 32, 0)", borderRadius: "5px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        
        
        </Box>

        <Table
          sx={{
            borderCollapse: "separate",
            borderSpacing: 0,
          }}
        > 
          <TableHead>
            <TableRow sx={{ borderRadius: "5px", backgroundColor: "#071019", }}>
              <TableCell sx={{ color: "white", fontWeight: "bold", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px", borderTop: "1px solid #394047", borderLeft: "1px solid #394047", borderBottom: "1px solid #394047"}}>Scenario Name</TableCell>
              <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold", textAlign: "center", borderTop: "1px solid #394047", borderBottom: "1px solid #394047" }}>Total Usage</TableCell>
              <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold", textAlign: "center", borderTopRightRadius: "5px", borderBottomRightRadius: "5px",borderTop: "1px solid #394047", borderRight: "1px solid #394047", borderBottom: "1px solid #394047"  }}>Unique Users</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {scenarioData.map((scenario) => (
              <TableRow key={scenario.scenario_name} hover sx={{ cursor: "pointer" }}>
                <TableCell sx={{ color: "white", borderBottom: "1px solid #262E36"  }}>{scenario.scenario_name}</TableCell>
                <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1px solid #262E36" }}>{scenario.overall_usage}</TableCell>
                <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1px solid #262E36" }}>{scenario.unique_users}</TableCell>
              </TableRow>
            ))}

            <TableRow>
              <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold", borderBottom: "1px solid #262E36" }}>Total</TableCell>
              <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold", textAlign: "center", borderBottom: "1px solid #262E36" }}>{totalUsage}</TableCell>
              <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold", textAlign: "center", borderBottom: "1px solid #262E36" }}>{totalUsers}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default Scenarios;
